import UserRepository from "../../ports/userRepository";
import { User } from "../../../entities/user";

export type updateUserUsecase = (
  uid: string,
  data: Partial<User>
) => Promise<void>;

export const buildUpdateUser = (dependencies: {
  userRepo: UserRepository;
}): updateUserUsecase => {
  const { userRepo } = dependencies;

  const updateUser = async (uid: string, data: Partial<User>) =>
    userRepo.updateUser(uid, data);

  return updateUser;
};
